// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import OptionsSidebar from './OptionsSidebar';

class UnitsSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unitsOptions: [],
      filterLoaded: false,
      unitsSideBarOpened: false,
    }

    this.watchFilterOptionsStore = this.watchFilterOptionsStore.bind(this);
    this.handleUnitsOpenSidebar = this.handleUnitsOpenSidebar.bind(this);
    this.handleUnitsBackSidebar = this.handleUnitsBackSidebar.bind(this);
    this.handleUpdateField = this.handleUpdateField.bind(this);
  }

  componentDidMount() {
    this.watchFilterOptionsStore()
  }

  watchFilterOptionsStore() {
    window.store.FilterOptions.watch(state => {
      const { options, loading } = state;

      this.setState({
        unitsOptions: options.units || [],
        filterLoaded: !loading
      })
    })
  }

  handleUnitsOpenSidebar() {
    this.setState({
      unitsSideBarOpened: true,
    })
  }

  handleUnitsBackSidebar(event) {
    event.stopPropagation()

    this.setState({
      unitsSideBarOpened: false,
    })
  }

  handleUpdateField(filterKey) {
    return (event) => {
      const value = event.target.value;
      this.props.handleUpdateFilter(filterKey, value)
    }
  }

  render() {
    const {
      unitsOptions,
      unitsSideBarOpened,
    } = this.state;

    const { currentValue } = this.props;
    
    return ( 
      <div className="advanced-filter__units">
        <button
          className="btn button button--outline advanced-filter__select-button"
          onClick={this.handleUnitsOpenSidebar}
        >
          Selecionar unidades <i className="icon icon-arrow-d" />
        </button>

        {unitsSideBarOpened && (
          <OptionsSidebar
            handleButtonCloseClick={this.handleUnitsBackSidebar}
            title="Unidades"
            options={unitsOptions}
            activeItems={currentValue}
            handleUpdateField={this.handleUpdateField('units')}
          />
        )}
      </div>
    );
  }
}

UnitsSelect.defaultProps = {
  currentValue: [],
  handleUpdateFilter: () => {}
};

UnitsSelect.propTypes = {
  currentValue: PropTypes.arrayOf(),
  handleUpdateFilter: PropTypes.func,
};

export default UnitsSelect;
